import { getService } from 'reducers/service';
import ServiceName from '../../shared/constants/serviceName';

export const getPersonBulletins = async (personId) => {
  const service = getService(ServiceName.CadAlerts);
  return service.find({ query: { ptsPersonID: personId } });
};

export const getBulletin = async (alertId) => {
  const service = getService(ServiceName.CadSearchAlerts);
  return service.get(alertId);
};

export const createBulletin = async (data) => {
  const service = getService(ServiceName.CadSearchAlerts);
  return service.create(data);
};

export const updateBulletin = async (alertId, data) => {
  const service = getService(ServiceName.CadSearchAlerts);
  return service.update(alertId, data);
};

export const deleteBulletin = async (alertId) => {
  const service = getService(ServiceName.CadSearchAlerts);
  return service.remove(alertId);
};

export const getVehicleBulletins = async (vehicleId) => {
  const service = getService(ServiceName.CadAlerts);
  const response = await service.find({ query: { ptsVehicleID: vehicleId } });
  return response?.data || response || [];
};
